import type {
  ConsoleDatabase,
  ConsoleTable,
  ExecuteRequest,
  QueryResult,
} from '@speles7172/sql-console';
import { apiClient } from './client';

/**
 * The SQL Client endpoints, shaped by `SqlConsoleTransport`.
 *
 * Thin on purpose. The console builds the requests and reads the results; this
 * file only carries them, and the types come from the package rather than being
 * restated here — a second declaration of `QueryResult` is a second thing to
 * keep in step with the endpoint.
 */

export type { ConsoleDatabase, ConsoleTable, ExecuteRequest, QueryResult };

/** The picker: the live database, plus the backups where they are configured. */
export async function listDatabases(): Promise<ConsoleDatabase[]> {
  const { data } = await apiClient.get<ConsoleDatabase[]>('/admin/sql/databases');
  return data;
}

export async function listTables(database?: string): Promise<ConsoleTable[]> {
  const { data } = await apiClient.get<ConsoleTable[]>('/admin/sql/tables', {
    params: database === undefined ? undefined : { database },
  });
  return data;
}

export async function execute(request: ExecuteRequest): Promise<QueryResult> {
  const { data } = await apiClient.post<QueryResult>('/admin/sql/query', request);
  return data;
}
